import { AREA_LIST } from '../../mutationTypes'

const mutations = {
  [AREA_LIST](state, action){
    state.items = action.items
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./client/store/modules/area/areaMutations.js